define('components/boilerplate/collections/base',[], function () {
    "use strict";

    return Backbone.Collection.extend({
        "update": function (data) {
            _.each(data, function (item, index) {
                var origItem;

                if (item._id) {
                    origItem = this.findWhere({
                        "_id": item._id
                    });
                } else {
                    origItem = this.at(index);
                }

                if (!origItem) {
                    return;
                }

                origItem.update(item);
            }, this);
        },

        "toDataJSON": function (opts) {
            var withChildren;

            opts = opts || {};

            withChildren = !!opts.withChildren;

            return this.reduce(function (memo, item) {
                var itemVal = item,
                    dataMethod = opts.dataMethod || null;

                if (_.isString(dataMethod) && itemVal[dataMethod]) {
                    dataMethod = itemVal[dataMethod];
                }

                itemVal = itemVal && (dataMethod && dataMethod.call(itemVal, withChildren) ||
                                       itemVal.toJSON && itemVal.toJSON() ||
                                       itemVal);

                memo.push(itemVal);

                return memo;
            }, []);
        },

        "toAuthoringJSON": function (withChildren) {
            return this.toDataJSON({
                "dataMethod": "toAuthoringJSON",
                "withChildren": withChildren
            });
        },

        "getSaveStateJSON": function () {
            return this.toDataJSON({
                "dataMethod": "getSaveStateJSON",
                "withChildren": true
            });
        }
    });
});

